import React, { memo } from "react";

function Error({ value }) {
  if (!value) return null;
  return <div className="text-danger text-sm">{value}</div>
}

export default memo(Error);
